import { ActivatedRoute } from '@angular/router';
import { VariablesService } from './../../../shared/services/variables/variables.service';
import { first } from 'rxjs/operators';
import {
  Component, ElementRef, HostListener, Input, NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren
} from '@angular/core';
import { StorageService } from './../../../shared/services/storage/storage.service';
import { SignupService } from './../../../shared/services/signup/signup.service';
import { HomepageService } from '../../services/homepage.service';
import { environment } from '../../../../environments/environment.prod';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInUp } from 'ng-animate';
import { UtilService, EventsService, VwoService, CookieService } from '../../../shared/services';
import { StartfundraiserButtonComponent } from '../../../common/startfundraiser-button/components/startfundraiser-button/startfundraiser-button.component';
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  animations: [
    trigger('fadeOutUp', [transition('* => *', useAnimation(fadeInUp))])
  ]
})
export class BannerComponent implements OnInit, OnDestroy {

  fadeOutUp: any;
  /**
   * Array of obects containing banner data
   */
  banners = [];
  /**
   * Banner being currently displayed
   */
  activeBanner;
  /**
   * Active banner's index
   */
  bannerActiveIdx = 0;
  /**
   * true if the device is mobile
   */
  @ViewChild('whatsAppSticky', { static: true }) public whatsAppSticky: ElementRef<HTMLElement>;
  isMobile: any;
  bannerServiceObservable;
  imageDomain = environment.APP.IMAGE_DOMAIN;
  public navIsFixed = false;
  isUrgentFundraiser = false;
  urgentFrData: any;
  urgentFRObservable;

  response: any;
  @ViewChildren('bannerAnim') public bannerAnim: QueryList<any>;

  @Input() public position;

  // sac fundraiser button component initialised
  // tslint:disable-next-line: max-line-length
  sacComp;

  alternateLangSAC = 'नि: शुल्क फंडरेजर शुरू करें';
  alternateLang = 'Hindi';

  isAnyActiveSip;

  constructor(
    private homepageService: HomepageService,
    public utilService: UtilService,
    private zone: NgZone,
    public eventsService: EventsService,
    private signupService: SignupService,
    public storageService: StorageService,
    private variablesService: VariablesService,
    public vwo: VwoService,
    private actRoute: ActivatedRoute,
    private cookieService: CookieService
  ) { }
  subs = [];
  userData;
  isLoggedIn;
  // for temp loggedin user
  isTempUser;
  isAppUser;

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.getBanner();
    this.getUrgetnFr();
    this.setAlternateLang();
    if (typeof document !== 'undefined') {
      this.sacComp = new StartfundraiserButtonComponent(
        this.utilService, document, this.signupService, this.storageService, this.eventsService
      );
    }
    this.subs.push(this.variablesService.userData.subscribe(res => {
      this.userData = res;
      if ([1, 2].includes(this.utilService.checkForActiveSip(this.userData?.listsubscriptions))) {
        this.isAnyActiveSip = true;
      }
    }));

    // checks for '@' in url for temp login user
    this.subs.push(this.actRoute.queryParams.subscribe(queryParams => {
      if (Object.keys(queryParams).length > 0 && Object.values(queryParams).some(val => val.includes('@')) && !this.isLoggedIn) {
        this.isTempUser = true;
      }
    }));

    this.subs.push(this.utilService.isLoggedIn.subscribe(val => {
      this.isLoggedIn = val;
      if (val) {
        this.isTempUser = val;
      }
    }));
    this.isAppUser = this.cookieService.getCookie('platform');
  }

  setAlternateLang() {
    const validTeluguLocation = ['Andhra Pradesh', 'Telangana'];
    const validTamilLocation = ['Tamil Nadu'];
    this.variablesService.clientLocationData.subscribe(res => {
      if (res) {
        if (validTeluguLocation.includes(res.region_name)) {
          this.alternateLangSAC = 'మీ ఫండ్రైజెర్ని ఉచితంగా ప్రారంభించండి';
          this.alternateLang = 'Telugu';
        } else if (validTamilLocation.includes(res.region_name)) {
          this.alternateLangSAC = 'இலவசமாக ஒரு நிதி திரட்டலைத் தொடங்குங்கள்';
          this.alternateLang = 'Tamil';
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.bannerServiceObservable) {
      this.bannerServiceObservable.unsubscribe();
    }
    if (this.urgentFRObservable) {
      this.urgentFRObservable.unsubscribe();
    }
    this.subs.forEach(sub => sub.unsubscribe());
  }

  /*Urgent fundraiser widget */
  getUrgetnFr() {
    if (this.utilService.isBrowser) {
      this.urgentFRObservable = this.homepageService.getUrgentFR().subscribe(
        (res: any) => {
          if (res.data.data.length) {
            this.isUrgentFundraiser = true;
          }
          this.urgentFrData = res.data.data;
        }
      );
    } else {
      this.isUrgentFundraiser = false;
    }
  }

  /**
   * Setting the banner's text on banner change via Swiggy effect.
   * @param {number} index Active banner's index
   */
  onSwiperIndexChange(index: number) {
    this.zone.run(() => {
      this.banners.forEach((item, i) => {
        this.activeBanner = this.banners[index];
        this.fadeOutUp = this.activeBanner ? this.activeBanner.id : 0;
      });
    });
  }

  /**
   * Gets banner for homepage
   */
  getBanner() {
    this.bannerServiceObservable = this.homepageService.getBanner().subscribe(
      (res: any) => {
        this.activeBanner = res.data.data[0];
        this.banners = res.data.data;
      }
    );
  }

  getBannerImage(banner): string {
    if (this.isMobile && banner.mobile && banner.mobile.cdn_path) {
      return banner.mobile.cdn_path;
    } else {
      return banner.desktop.cdn_path;
    }
  }

  hindiSAC() {
    this.storageService.add('language', this.alternateLang);
    this.sacComp.sendEvent(this.alternateLang);
  }

  /*sticky donate button */
  whatsappToggle(event) {
    if (this.banners.length && this.whatsAppSticky) {
      if (event.visible === true) {
        this.whatsAppSticky.nativeElement.children[0].classList.remove('whatsapp-share-sticky');
        this.whatsAppSticky.nativeElement.children[0].classList.add('whatsapp-share-unstick');
      } else if (event.visible === false) {
        this.whatsAppSticky.nativeElement.children[0].classList.add('whatsapp-share-sticky');
        this.whatsAppSticky.nativeElement.children[0].classList.remove('whatsapp-share-unstick');
      }
    }

  }
  /*Events for whatsapp mobile */
  pushWhatsappEvent(event) {
    this.eventsService.userGTMEvents({
      event: 'chat_click',
      event_category: 'navigation',
      event_action: 'whatsapp chat click',
      event_label: `${event.target.innerText}|body`
    });
    const payload = {
      eventName: 'wa_chat_with_us',
      event_type: 'campaign',
      info_1: 'type',
      info_2: 6
    };
    this.eventsService.sendSystemEvent(payload).pipe(first()).subscribe((data) => {
      this.openWhatsApp();
    }, () => this.openWhatsApp());
  }

  openWhatsApp() {
    if (typeof window !== 'undefined') {
      const url = 'https://api.whatsapp.com/send?phone=91' + this.variablesService.contactUsMobNumber + '&text=Hi,%20I%20am%20looking%20to%20start%20a%20fundraiser%20on%20Ketto';
      const target = window.navigator.userAgent.match('Firefox|Safari') ? '_self' : '_blank';
      window.open(url, target);
    }
  }

  /*Event for start a fundraiser banner button */
  sendEvent() {
    if (typeof window !== 'undefined') {
      const payload = {
        eventName: 'start_a_campaign_initiated',
        event_type: 'campaign',
        page_name: 'home',
        referrer_page: document.referrer,
        info_1: 'type',
        info_2: 'home_1',
        event_type_id: ''
      };
      this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
      this.storageService.checkFromSession('sac-initiated', payload);
      this.signupService.startFR();
    }
  }

  /* start a fundraiser dock strip */
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (typeof window !== 'undefined') {
      const number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (number > 500) {
        this.navIsFixed = true;
      } else if (this.navIsFixed && number < 500) {
        this.navIsFixed = true;
      }
    }
  }

}

